<template>
  <q-dialog v-model="visible" persistent>
    <q-card class="container">
      <div class="modal-header">
        <q-card-section class="header">
          <div class="header-content-wrapper">
            <div class="header-title">{{ cacambaData.code }} - {{ this.$gettext('INDUSTRIAL_MAP_BUCKET_DUMPSTER') }} - {{ cacambaData.apelido }}</div>
            <q-btn flat round color="white" icon="close" @click="onClose" class="header-close-btn" />
          </div>
        </q-card-section>
      </div>

      <div class="modal-body">
        <div class="content">
          <div v-if="loading" class="loading-section">
            <q-inner-loading :showing="loading">
              <q-spinner-gears size="80px" color="primary" />
            </q-inner-loading>
          </div>

          <div v-if="hasError" class="text-negative text-center q-pa-md">
            {{ errorMessage }}
          </div>

          <div v-else-if="!loading">
            <div class="container1">
              <div class="div-inside-container1">
                <div class="card-hoje">
                  <div class="info-title">{{ this.$gettext('INDUSTRIAL_MAP_GENERAL_INFO') }}</div>
                  <div class="info-grid">
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_ACTIVITY_START') }}</div>
                      <div class="info-value">{{ cacambaData.inicioAtividade }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_CONTAINER_LOCATION') }}</div>
                      <div class="info-value">{{ cacambaData.local }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_CONTAINER_PICKUP') }}</div>
                      <div class="info-value">{{ cacambaData.recolhimento }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_CONTAINER_ALLOCATED_TIME') }}</div>
                      <div class="info-value">{{ cacambaData.tempoAlocado }}</div>
                    </div>
                    <div class="info-row">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_RESPONSIBLE') }}</div>
                      <div class="info-value">{{ cacambaData.responsavel }}</div>
                    </div>
                    <div class="info-row full-width">
                      <div class="info-label">{{ this.$gettext('INDUSTRIAL_MAP_OBSERVATION') }}</div>
                      <div class="info-value">{{ cacambaData.observacao }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <q-card-actions align="center" class="footer">
          <q-btn :label="$gettext('INDUSTRIAL_MAP_BTN_CLOSE')" color="grey-7" class="btn-fechar" @click="onClose" />
        </q-card-actions>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  name: 'ModalCacambaTemporaria'
})
class ModalCacambaTemporaria extends Vue {
  @Prop({ type: Boolean, default: false })
  value

  @Prop({ type: Object, default: () => ({}) })
  cacamba

  loading = false
  hasError = false
  errorMessage = ''
  cacambaDetails = null

  get visible () {
    return this.value
  }

  set visible (val) {
    this.$emit('input', val)
  }

  get cacambaData () {
    return this.cacambaDetails || {
      code: this.cacamba?.bucketCode,
      apelido: this.cacamba?.collectionPointName,
      inicioAtividade: this.cacamba?.startActivity,
      local: this.cacamba?.collectionPointName,
      recolhimento: 'Não Recolhido',
      tempoAlocado: this.cacamba?.allocatedTimeInDays + ' dias',
      responsavel: this.cacamba?.email,
      observacao: '-'
    }
  }

  onClose () {
    this.visible = false
    this.$emit('close')
  }

  @Watch('visible')
  async onModalOpen (isVisible) {
    if (isVisible && this.cacamba?.id) {
      await this.loadCacambaDetails()
    }
  }
}

export default ModalCacambaTemporaria
</script>

<style lang="stylus" scoped>
.container
  width: 920px
  max-width: 920px
  height: 400px
  max-height: 400px
  border-radius: 10px
  padding-top: 16px
  background: white
  display: flex
  flex-direction: column
  gap: 20px
  box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px rgba(0,0,0,0.14), 0 1px 10px rgba(0,0,0,0.12)

.modal-header
  flex-shrink: 0;

.header
  height: 50px
  padding: 8px 20px
  border-radius: 4px
  color: white !important
  flex-shrink: 0
  background-color: #1E4971

.coletas-realizadas-header
  background-color: #0F5295

.header-content-wrapper
  width: 856px
  height: 34px
  gap: 20px
  display: flex
  align-items: center
  justify-content: space-between
  margin: 0 auto

.header-title
  height: 34px
  font-family: Roboto
  font-weight: 700
  font-style: Bold
  font-size: 28px
  line-height: 34px
  flex-grow: 1

.text-header-card-hoje
  font-family: Roboto;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;

.header-close-btn
  flex-shrink: 0
  cursor: pointer; /* Add cursor pointer for better UX */
  margin: 0;

.modal-body
  height: 400px; /* Adjusted height */
  overflow-y: auto;
  padding: 0px 16px 0px 0px; /* Add padding to right */

.content
  gap: 8px
  display: flex
  flex-direction: column
  flex-grow: 0
  padding: 0px 0px 0px 16px; /* Add padding to left */
  width: 888px;

.modal-footer
  flex-shrink: 0;

.footer
  height: 60px
  gap: 20px
  padding: 12px 0; /* Add padding to top and bottom */
  background: #FFFFFF /* Change background color */
  display: flex
  justify-content: center /* Center the button horizontally */
  align-items: center
  flex-shrink: 0

.container1
  width: 888px
  gap: 20px
  display: flex
  flex-direction: column
  flex-shrink: 0

.container2
  width: 888px
  gap: 8px
  display: flex
  flex-direction: column
  flex-grow: 0
  overflow-y: auto

.text-modal-body
  color: #31CCCB

.div-inside-container1
  width: 888px
  gap: 16px
  border-width: 1px
  border-radius: 8px
  padding: 16px
  background: #FCFCFC
  border: 1px solid #E0E0E0
  display: flex
  flex-direction: column
  flex-shrink: 0

.div-subtitulo
  width: 149px
  height: 21px
  gap: 10px
  border-bottom: 2px solid #0062a9
  display: flex
  align-items: center
  flex-shrink: 0

.container-coletas
  width: 856px
  height: 128px
  gap: 16px
  display: flex
  flex-direction: row
  justify-content: space-between
  flex-shrink: 0

.coletas-feitas-block, .qtd-coletada-block
  width: 420px
  height: 128px
  padding: 16px
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  border-radius: 8px
  flex-shrink: 0

.card-hoje
  width: 856px
  gap: 8px
  border-radius: 8px
  padding: 12px
  border-left: 3px solid #0679CC
  background: #FFFFFF
  overflow-y: hidden
  flex-shrink: 0

.info-title
  font-size: 18px
  font-weight: 500
  color: #424242
  margin-bottom: 12px
  padding-bottom: 0
  border-bottom: none

.info-grid
  display: grid
  grid-template-columns: repeat(3, 1fr)
  gap: 8px

.info-row
  display: flex
  background: #F2F2F2
  border-radius: 4px
  height: 26;
  angle: 0 deg;
  opacity: 1;
  padding: 8px;
  gap: 10px;

.info-row.full-width
  grid-column: 1 / -1

.info-label
  font-family: Roboto;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  leading-trim: CAP_HEIGHT;
  line-height: 100%;
  letter-spacing: 0%;
  color: #0f5295

.info-value
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  leading-trim: CAP_HEIGHT;
  line-height: 100%;
  letter-spacing: 0%;
  color: #707070;

.btn-fechar
  width: 120px

.loading-section
  min-height: 200px
  display: flex
  align-items: center
  justify-content: center
  padding-top: 40px
  padding-bottom: 40px
  flex-grow: 1
</style>
